import styled from "styled-components" // eslint-disable-line no-restricted-imports

export const NavBar = styled.div`
  position: relative;
  z-index: 799; // Orbit modals are 800
  pointer-events: all;
`
